import clsx from "clsx";
import { useEffect, useState } from "react";
import { AspectRatio } from "@repo/ui/aspect-ratio";
import * as Flex from "@repo/ui/flex";
import { PlayIcon as Play } from "../icons/play";
import { VIDEO_NO_SOUND } from "./config";
import { useVideoPlayer } from "./hooks/useVideoPlayer";
import VideoControls from "./video-controls";
import styles from "./video-overlay.module.css";

export type VideoOverlayProps = {
  onFinish?: () => void;
  videoFinished: boolean;
};

export default function VideoOverlay({
  onFinish,
  videoFinished,
}: VideoOverlayProps) {
  const {
    videoRef,
    handleInteraction,
    handleSkip,
    showPlayButton,
    handlePlayButtonClick,
  } = useVideoPlayer({ onFinish });
  const [videoFaded, setVideoFaded] = useState(false);

  useEffect(() => {
    if (videoFinished) {
      setTimeout(() => {
        setVideoFaded(true);
      }, 500);
    }
  }, [videoFinished]);

  return (
    <Flex.Container
      column
      justify="center"
      align="center"
      onClick={handleInteraction}
      className={clsx(
        styles.videoOverlay,
        videoFaded && styles.hidden,
        videoFinished && styles.fadeOut,
      )}
    >
      <AspectRatio
        ratio={VIDEO_NO_SOUND.ASPECT_RATIO}
        className={clsx(
          styles.videoContainer,
          videoFinished && styles.translateY,
        )}
      >
        <video
          ref={videoRef}
          aria-description={VIDEO_NO_SOUND.DESCRIPTION}
          playsInline
          onEnded={onFinish}
        >
          <source type="video/mp4" src={VIDEO_NO_SOUND.SOURCES[1].src} />
          <source type="video/webm" src={VIDEO_NO_SOUND.SOURCES[0].src} />
          <track kind="captions" />
        </video>
        {showPlayButton && (
          <button
            className={styles.playButtonOverlay}
            onClick={handlePlayButtonClick}
            data-testid="play-button"
          >
            <Play />
          </button>
        )}
      </AspectRatio>
      <VideoControls onSkip={handleSkip} />
    </Flex.Container>
  );
}
